import { Component, EventEmitter, OnInit, Output , ChangeDetectorRef } from '@angular/core';
import { WizardStateService } from '../../../services/wizard-state.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-global-context-step-2',
    templateUrl: './global-context-step-2.component.html',
    styleUrls: ['./global-context-step-2.component.scss'],
    standalone: false
})
export class GlobalContextStep2Component implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() back = new EventEmitter<void>();

  mapName = '';

  // Form Fields
  creationStory = '';
  uniqueFeatures = '';
  customsHolidays = '';
  techInnovations = '';

  // Validation
  showErrorMsg = false;
  validationErrorText = '';

  constructor(private stateService: WizardStateService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.stateService.state.pipe(take(1)).subscribe(state => {
      this.mapName = state.mapName || 'World';

      // Restore values from state if they exist
      if (state.globalContext) {
        const gc = state.globalContext;
        this.creationStory = gc.creationStory || '';
        this.uniqueFeatures = gc.uniqueFeatures || '';
        this.customsHolidays = gc.customsHolidays || '';
        this.techInnovations = gc.techInnovations || '';
      }
      this.cdr.detectChanges();
    });
  }

  onNext(): void {
    this.showErrorMsg = false;
    this.validationErrorText = '';

    // Validate fields
    if (!this.creationStory.trim()) {
      this.validationErrorText = 'Creation Story is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.uniqueFeatures.trim()) {
      this.validationErrorText = 'Unique World Features is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.customsHolidays.trim()) {
      this.validationErrorText = 'Global Customs/Holidays is required.';
      this.showErrorMsg = true;
      return;
    }
    if (!this.techInnovations.trim()) {
      this.validationErrorText = 'Key Technological Innovations is required.';
      this.showErrorMsg = true;
      return;
    }

    // Save state
    this.stateService.updateState({
      globalContext: {
        ...this.stateService.currentState.globalContext,
        creationStory: this.creationStory,
        uniqueFeatures: this.uniqueFeatures,
        customsHolidays: this.customsHolidays,
        techInnovations: this.techInnovations
      }
    });

    this.next.emit();
  }

  onBack(): void {
    this.stateService.updateState({
      globalContext: {
        ...this.stateService.currentState.globalContext,
        creationStory: this.creationStory,
        uniqueFeatures: this.uniqueFeatures,
        customsHolidays: this.customsHolidays,
        techInnovations: this.techInnovations
      }
    });
    this.back.emit();
  }
}
